export default "__VITE_ASSET__C2$C4qxh__"